import React, { Component } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { makeCustomerCharge } from '../../actions/InvoiceAction';
import { getInvoices, getInvoiceAmounts } from '../../actions/AccountingActions';
import { getCustomerCreditCards } from '../../actions/PaymentAction';
import { formatDate, parseDate } from 'react-day-picker/moment';
import { connect } from 'react-redux';
import { qpClosemodal } from '../../utils/misc';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';

class PayModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current_invoices: [],
            currentTotal: 0.0,
            InvoiceNumbers: [],
            InvoicePayments: [],
            PaymentMethod: "",
            ReferenceNumber: "",
            PaymentDate: "",
            PaymentComment: "",
            PaymentAmount: "",
            Token: "",
            customerId: 0,
            StripeId: "",
            activeTab: 'all',
            searchTerm: '',
            pageIndex: 0,
            maxRows: 25,
            isLoadingModal: false
        }
    }

    componentDidMount() {
        this.props.getCustomerCreditCards();
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.payButtonDisable !== this.state.buttonDisable) {
            this.setState({
                buttonDisable: nextProps.payButtonDisable,
                ReferenceNumber: "",
                PaymentDate: ""
            })
        }

        if (nextProps.selectedInvoices.length !== 0 && nextProps.selectedInvoices !== this.state.InvoiceNumbers) {

            this.setState({
                InvoiceNumbers: []
            })

            let selected_invoice_numbers = [...nextProps.selectedInvoices];
            let invoicesList = nextProps.invoiceList;
            let selected_invoices_list = []
            selected_invoices_list = invoicesList.filter((i) => selected_invoice_numbers.includes(i.invoiceNumber));

            this.setState({
                current_invoices: selected_invoices_list,
                InvoiceNumbers: selected_invoice_numbers,
                customerId: nextProps.customerId,
                currentTotal: nextProps.selectedAmount
            }, () => {
                var size = this.state.InvoiceNumbers.length;
                var initial_payments = new Array(size)
                for (var i = 0; i < size; i++) {
                    initial_payments[i] = selected_invoices_list[i].balance
                };
                this.setState({
                    InvoicePayments: [...initial_payments]
                })
            })
        }
    }

    _changeAmount(invoice, event) {
        var eventName = event.target.name.split("-");
        let amount = event.target.value == "" ? 0 : event.target.value
        if (amount === 0) {
            var invoiceIndex = this.state.InvoiceNumbers.findIndex(x => x === parseInt(eventName[2], 10))
            var x = [...this.state.InvoicePayments]
            x[invoiceIndex] = 0;

            this.setState({
                InvoicePayments: x,
                currentTotal: x.reduce(this.sumofArray)
            })
        }
        else if (invoice.balance >= parseFloat(amount) && parseFloat(amount) > -1) {
            amount = amount === 0 ? parseFloat(invoice.balance) : amount;
            invoice.payAmount = parseFloat(amount)
            invoiceIndex = this.state.InvoiceNumbers.findIndex(x => x === parseInt(eventName[2], 10))
            x = [...this.state.InvoicePayments]
            x[invoiceIndex] = invoice.payAmount;
            this.setState({
                InvoicePayments: x,
                currentTotal: x.reduce(this.sumofArray)
            })
        }
        else {

            invoiceIndex = this.state.InvoiceNumbers.findIndex(x => x === parseInt(eventName[2], 10))
            x = [...this.state.InvoicePayments]
            x[invoiceIndex] = invoice.balance;

            this.setState({
                InvoicePayments: x,
                currentTotal: x.reduce(this.sumofArray)
            })
        }
    }

    sumofArray(sum, num) {
        return sum + num;
    }

    _selectedCard = (event) => {

        if (event.target.value !== "-1") {
            let index = event.target.selectedIndex

            this.setState({
                Token: event.target.value,
                StripeId: event.target[index].dataset.cust
            })
        }
        else {

            this.setState({
                Token: "",
                StripeId: ""
            })
        }

    }

    handleChangeReferenceNumber = (e) => {
        this.setState({ ReferenceNumber: e.target.value });
    }

    handleDayChange = (day) => {
        this.setState({ paymentDate: formatDate(day, 'L', 'en') });
    }

    onCloseModal = () => {
        this.setState({ ReferenceNumber: "" });
    }

    _payClick() {

        this.setState({
            PaymentAmount: this.state.currentTotal.toString(),
            PaymentDate: document.getElementById("PaymentDate").value,
            PaymentComment: document.getElementById("PaymentComment").value,
            ReferenceNumber: document.getElementById("ReferenceNumber").value,
            PaymentMethod: "4",
            isLoadingModal: true,
            buttonDisable: true
        }, () => {

            if (this.state.Token === "" && this.state.StripeId === "") {

                toast.error('Please select card', {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });

                this.setState({
                    isLoadingModal: false,
                    buttonDisable: false
                })

            } else {
                this.props.makeCustomerCharge(this.state).then(() => {

                    this.setState({
                        isLoadingModal: false
                    })

                    qpClosemodal("#invoice-pay-modal");
                    const { activeTab, maxRows, pageIndex } = this.state;
                    this.props.getInvoiceAmounts();
                    this.props.getInvoices(activeTab, pageIndex, maxRows, "");

                });
            }
        })
    }

    render() {

        const { cards } = this.props;

        return (
            <div className="modal fade" id="invoice-pay-modal" tabIndex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                data-backdrop="static"
                data-keyboard="false"
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header mb-4" style={{ borderBottom: "1px solid #D8D8D8" }}>
                            <h5 className="modal-title"><i style={{ color: "#4285F4" }} className="fas fa-coins fa-lg"></i>&nbsp; Make Payment</h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => this.onCloseModal()} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="row m-0 mb-4 pl-4">
                            <div className="col-12 m-0 mb-4">
                                <div className="form-group row">
                                    <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Select Credit Card</label>
                                    <div className="col-sm-6">
                                        <select className="form-control" id="payment-method" name="card" onChange={this._selectedCard} required>
                                            <option value="-1">Select card from List</option>
                                            { (cards || []).map((card, index) => {
                                                    return (
                                                        <option key={index} value={card.id} data-cust={card.customer}>{card.last4 + "    " + card.exp_month + " / " + card.exp_year + "    " + card.brand}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Amount</label>
                                    <div className="col-sm-6">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">$</span>
                                            </div>
                                            <input type="text" className="form-control" id="selectedTotalBalance" value={this.state.currentTotal.toFixed(2)} disabled="disabled" style={{ textDecoration: "none" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div id="selectedInvoices" className="col-sm-10">
                                        {this.state.current_invoices !== undefined && this.state.current_invoices.length > 0 ?
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center"> Invoice # </th>
                                                        <th className="text-center"> Total </th>
                                                        <th className="text-center"> Balance </th>
                                                        <th className="text-center">Payment Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.current_invoices.map((invoice, index) => {

                                                        if (this.state.InvoicePayments[index] !== undefined) {
                                                            return (
                                                                <tr key={invoice.invoiceNumber}>
                                                                    <td className="text-center">{invoice.invoiceNumber}</td>
                                                                    <td className="text-center">{invoice.totalAmount}</td>
                                                                    <td className="text-center">{invoice.balance}</td>
                                                                    <td className="text-center">
                                                                        <input type="text" className="form-control" value={

                                                                            this.state.InvoicePayments[index] === 0 ? "" : this.state.InvoicePayments[index]} max={invoice.balance} name={"payment-amount-" + invoice.invoiceNumber}
                                                                            onChange={(e) => this._changeAmount(invoice, e)} />
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                    }
                                                    )}
                                                </tbody>
                                            </table> : null
                                        }
                                    </div>

                                </div>
                                <div className="form-group row">
                                    <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Payment Date</label>
                                    <div className="col-sm-6">
                                        <DayPickerInput
                                            formatDate={formatDate}
                                            format="L"
                                            parseDate={parseDate}
                                            placeholder={`${formatDate(new Date(), 'L', 'en')}`}
                                            onDayChange={this.handleDayChange}
                                            inputProps={{ name: 'PaymentDate', id: 'PaymentDate', className: 'form-control', type: 'text', style: { width: 344 } }}
                                            value={this.state.PaymentDate}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Reference Number</label>
                                    <div className="col-sm-6">
                                        <input type="text" className="form-control" id="ReferenceNumber" placeholder="Check/Payment Number" onChange={this.handleChangeReferenceNumber}
                                            value={this.state.ReferenceNumber} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="colFormLabelSm" className="col-sm-4 col-form-label col-form-label-sm">Payment Note</label>
                                    <div className="col-sm-6">
                                        <textarea className="form-control" id="PaymentComment" rows="2" placeholder="Type here.." /*onChange={this._paymentMethodChange.bind(this)}*/></textarea>
                                    </div>
                                </div>
                                <div className="row d-flex justify-content-center">
                                    {/*<span id="selectedInvoiceCount"><strong>{this.state.selectedInvoices.length}</strong></span><span><strong>&nbsp; invoice selected.</strong></span>*/}
                                </div>
                            </div>
                        </div>

                        <div className="row m-0 p-4 form-group d-flex justify-content-center" style={{ borderTop: "1px solid #D8D8D8" }}>
                            <button type="button" className="btn btn-success waves-effect waves-light btn-lg" onClick={() => { this._payClick() }} disabled={this.state.buttonDisable === true ? "disabled" : ""} style={{ textDecoration: "none" }} >
                                <div className="row">
                                    <div className="col-md-10">
                                        <label style={{ margin: "0px" }}>{"PAY"}</label>
                                    </div>
                                    <div className="col-md-2" style={{ padding: "0px", paddingTop: "3px" }}>
                                        <div className='sweet-loading' style={{ textAlign: 'center' }}>
                                            <ClipLoader
                                                sizeUnit={"px"}
                                                size={15}
                                                color={'white'}
                                                loading={this.state.isLoadingModal}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = state => {

    return {
        invoiceList: state.accountingData.list,
        cards: state.paymentData.cards,
        selectedInvoices: state.accountingData.selectedInvoices,
        selectedAmount: state.accountingData.selectedAmount,
        customerId: state.accountingData.customerId,
        payButtonDisable: state.accountingData.payButtonDisable
    }
}
const mapDispatchToProps = dispatch => {
    return {
        makeCustomerCharge: (state) => dispatch(makeCustomerCharge(state)),
        getCustomerCreditCards: () => dispatch(getCustomerCreditCards()),
        getInvoices: (tab, pIndex, rows, searchTerm) => dispatch(getInvoices(tab, pIndex, rows, searchTerm)),
        getInvoiceAmounts: () => dispatch(getInvoiceAmounts())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(PayModal)


// WEBPACK FOOTER //
// ./src/view/Invoice/InvoicePayModal.js